function youtubeEmbed() {

	if ( $('.video-embed').length ) {
        $('.video-embed').each(function() {
            const $this = $(this),
                  videoID = $this.attr('data-video-id');

            videojs('#youtube-' + videoID).ready(function() {
                $('iframe', $this).attr('tabindex', -1);
            });
        });
    }

}